import { render, staticRenderFns } from "./AMGM_InequalityViz.vue?vue&type=template&id=311f4b5e&scoped=true"
import script from "./AMGM_InequalityViz.vue?vue&type=script&lang=js"
export * from "./AMGM_InequalityViz.vue?vue&type=script&lang=js"
import style0 from "./AMGM_InequalityViz.vue?vue&type=style&index=0&id=311f4b5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311f4b5e",
  null
  
)

export default component.exports